import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import { ExportVersionFile } from 'common/types';

const addVersion = {
  generateUUid: (taskId: number | string) => {
    return FastApiAxiosInstance.get('/api/v2/task/version/getVersionFileUUID', { params: { taskId } });
  },
  startDccCheck: (params: {
    uuid: string;
    fileList: ExportVersionFile[];
    description?: string;
    attachments?: any;
    modifyFileList?: ExportVersionFile[];
  }) => {
    return FastApiAxiosInstance.post('/api/v2/file/uploadEnd', params);
  },
  addVersionToServer: (params: { uuid: string; description?: string; fileList: any[] }) => {
    return FastApiAxiosInstance.post('/api/v1/task/version/addVersion', params);
  },
};
export default addVersion;
